import { defineComponent, openBlock, createElementBlock, createVNode, unref, mergeProps, createBlock, createCommentVNode } from "vue";
import ImageViewer from "../ImageViewer/ImageViewer.mjs";
import MediaCenterGrid from "./MediaCenterGrid/MediaCenterGrid.mjs";
const _hoisted_1 = {
  id: "apparel-media-image-container",
  class: "media-center",
  "aria-label": "Product images and videos"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "MediaCenter",
  props: {
    showImageViewer: {
      type: Boolean
    },
    imageViewerProps: {},
    mediaCenterGridProps: {}
  },
  emits: ["heroClick", "imageSelected", "imageZoomChange", "imageZoomClose", "metricsClick", "ugcImageClick", "ugcImageViewerSelect"],
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("section", _hoisted_1, [createVNode(unref(MediaCenterGrid), mergeProps(_ctx.mediaCenterGridProps, {
        onImageSelected: _cache[0] || (_cache[0] = (img) => _ctx.$emit("imageSelected", img)),
        onHeroClick: _cache[1] || (_cache[1] = (data) => _ctx.$emit("heroClick", data)),
        onUgcImageClick: _cache[2] || (_cache[2] = (data) => _ctx.$emit("ugcImageClick", data)),
        onMetricsClick: _cache[3] || (_cache[3] = (data) => _ctx.$emit("metricsClick", data)),
        onNextImage: _cache[4] || (_cache[4] = ($event) => _ctx.$emit("imageZoomChange", "forward")),
        onPrevImage: _cache[5] || (_cache[5] = ($event) => _ctx.$emit("imageZoomChange", "back")),
        onUgcImageViewerSelect: _cache[6] || (_cache[6] = (data) => _ctx.$emit("ugcImageViewerSelect", data))
      }), null, 16), _ctx.showImageViewer ? (openBlock(), createBlock(unref(ImageViewer), mergeProps({
        key: 0
      }, _ctx.imageViewerProps, {
        onNextImage: _cache[7] || (_cache[7] = ($event) => _ctx.$emit("imageZoomChange", "forward")),
        onPrevImage: _cache[8] || (_cache[8] = ($event) => _ctx.$emit("imageZoomChange", "back")),
        onImageZoomClose: _cache[9] || (_cache[9] = () => _ctx.$emit("imageZoomClose")),
        onUgcImageViewerSelect: _cache[10] || (_cache[10] = (data) => _ctx.$emit("ugcImageViewerSelect", data)),
        onMetricsClick: _cache[11] || (_cache[11] = (data) => _ctx.$emit("metricsClick", data))
      }), null, 16)) : createCommentVNode("", true)]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=MediaCenter.mjs.map
